// todo: important!
// todo: this is the same component as Card in packages/onboarding but we
// todo: need to reconsider the naming due to conflict with the common/Card component

import { tw } from "../../styling/helpers";
import { flexDirections } from "../../styling/theme";

type Props = {
	className?: string;
	children: React.ReactNode;
	fullWidth?: boolean;
	direction?: "row" | "col";
	boxShadow?: boolean;
	stretch?: boolean;
};

export const SmallCard = ({
	children,
	className,
	fullWidth,
	direction = "row",
	boxShadow = true,
	stretch,
}: Props) => {
	const classes = tw(
		`tablet:w-auto tablet:flex-row z-30 flex w-full flex-col rounded-lg px-6 py-4 text-left`,
		"bg-background-primary",
		className,
		boxShadow && "drop-shadow-lg",
		fullWidth && "tablet:w-full",
		flexDirections[direction],
		stretch && "self-stretch",
	);

	return <div className={classes}>{children}</div>;
};
